var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"rect-loading",rawName:"v-rect-loading",value:(_vm.loading),expression:"loading"}],staticClass:"email-template-list"},[_c('TableList',{attrs:{"noHead":"","listData":_vm.listData,"tableColumns":_vm.tableColumns,"actionBtn":_vm.actionBtn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }